"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OneTimeTokenOut = void 0;
class OneTimeTokenOut {
    constructor() {
    }
    static getAttributeTypeMap() {
        return OneTimeTokenOut.attributeTypeMap;
    }
}
exports.OneTimeTokenOut = OneTimeTokenOut;
OneTimeTokenOut.discriminator = undefined;
OneTimeTokenOut.attributeTypeMap = [
    {
        "name": "token",
        "baseName": "token",
        "type": "string",
        "format": ""
    }
];
//# sourceMappingURL=OneTimeTokenOut.js.map